import DA from './DA.svg';
import FindSolutions from './FindSolutions.svg';
import Formulation from './Formulation.svg';
import SearchLeft from './SearchLeft.svg';
import DocumentAnalyzer from './DocumentAnalyzer.svg';
import SubstanceInquiry from '@/assets/icon/playbooks/substance_search.svg';
import StructureSearch from '@/assets/icon/playbooks/structure_search.svg';
import WorkflowSearch from '@/assets/icon/playbooks/workflow_search.svg';
import MetalSearch from '@/assets/icon/playbooks/metal_search.svg';
import PropertySearch from '@/assets/icon/playbooks/property_search.svg';
import ReverseEngineering from '@/assets/icon/products/ReverseEngineering.svg';

export default {
  DA,
  FindSolutions,
  Formulation,
  SearchLeft,
  DocumentAnalyzer,
  SubstanceInquiry,
  StructureSearch,
  WorkflowSearch,
  MetalSearch,
  PropertySearch,
  ReverseEngineering,
};
